import React, { useContext } from "react"
import { Box, Typography, Button } from "@material-ui/core"
import PersonIcon from "@material-ui/icons/Person"
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount"
import BookIcon from "@material-ui/icons/Book"
import { UserContext } from "../contexts/UserContext"

const UserStatus = () => {
  const { user, onLogout } = useContext(UserContext)
  if (!user) return null
  const { accessLevel } = user
  const username = user.name ? user.name : user.email

  return (
    <Box item display="flex" alignItems="center" justifyContent="flex-end">
      <Typography>{username}</Typography>
      <Button
        item
        raised
        disableRipple
        onClick={onLogout}
        style={{ marginLeft: "10px" }}
        startIcon={
          accessLevel === "READ" ? (
            <BookIcon />
          ) : accessLevel === "ADMIN" ? (
            <SupervisorAccountIcon />
          ) : (
            <PersonIcon />
          )
        }
        color="secondary"
      >
        Logout
      </Button>
    </Box>
  )
}

export default UserStatus
